/**
 * Whether the Become a Member modal should mount for signed-in users.
 *
 * Always true: navbar/CTA can open it on any page. Auto-open is gated
 * separately in Onboarding via restrictedPaths.
 *
 * @param _pathname - Current route pathname (unused; kept for call-site clarity)
 * @returns Always true
 */
export const shouldMountBecomeAMemberModal = (
	_pathname?: string | null,
): boolean => true;

/**
 * Whether other signed-in chrome modals (profession, annotations, etc.)
 * should mount. Restricted paths suppress these to avoid clutter on
 * auth/checkout/exam flows.
 *
 * @param pathname - Current route pathname
 * @param restricted - Paths that suppress chrome modals
 * @returns False when pathname is under a restricted path
 */
export const shouldMountSignedInChromeModals = (
	pathname: string | null | undefined,
	restricted: readonly string[],
): boolean => {
	if (!pathname) return true;
	return !restricted.some((path) => pathname.startsWith(path));
};
